

// Standard YAML's Core schema.
// http://www.yaml.org/spec/1.2/spec.html#id2804923
//
// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
// So, Core schema has no distinctions from JSON schema is JS-YAML.


'use strict';

declare function require(n:string):any

import {Schema} from '../schema';


export = new Schema({
  include: [
    require('./json')
  ]
});
